import { createSearchParams } from "react-router-dom";
import SphereNavigationRoutes from "./sphere-navigation-routes";


// sphere query params and also some mapping parameters for webapp
export enum FilterKeys {
  Organization = "org",
  RobotId = "rid",
  MissionId = "m",
  MissionHistoryId = "mh",
  UserId = "u",
  Year = "year",
  PageSize = "ps",
  Page = "page",
  Search = "s",
  InviteToken = "it",
  StartDate = "start",
  Tab = "tab",
  EndDate = "end",
  Report = "report",
  All = "all",
  EndedDeployments = "ended",
  RoomId = "roomId",
  FloorId = "floorId",

  FleetDashboard = "fd",
  FleetDataset = "ds",
  DashboardView = "dv",
  RobotModel = "model",
  Dealer = "dealer",
  Customer = "customer",
  Tag = "tag",
  Country = "country",
  RobotScope = "scope",
  DatePeriod = "period"
}


interface Filters extends Record<string, string | string[] | boolean | null | undefined> {
  org?: string;
  all?: boolean;
  year?: string;
  rid?: string;
  it?: string;
  m?: string;
  u?: string;
  ps?: string;
  page?: string;
  s?: string;
  start?: string;
  end?: string;
}

export default Filters;

export const navigateSphereWithFilters = (route: SphereNavigationRoutes | string, org?: boolean, filters?: Filters) => {
  route = org ? `${SphereNavigationRoutes.Dashboard}${route}` : route;
  return filters == null
    ? route
    : {
        pathname: route,
        search: customCreateSearchParams(filters),
      };
};

export const customCreateSearchParams = (filters: any) => {
  const cleanedFilters = {} as Record<string, string | string[]>;

  Object.keys(filters).forEach((key) => {
    const value = filters[key];
    if (value != null) {
      if (typeof value === "boolean") {
        cleanedFilters[key] = value.toString();
      }
      else if (Array.isArray(value)) {
        cleanedFilters[key] = value.join(",")
      } else {
        cleanedFilters[key] = value;
      }
    }
  });

  return createSearchParams(cleanedFilters).toString();
};
